var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "app-connecting",
      class: "theme-" + _vm.theme,
      attrs: { id: "app" }
    },
    [_vm._m(0)]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "animation-outer" }, [
      _c("div", { staticClass: "animation-inner" }, [
        _c("img", {
          staticClass: "logo",
          attrs: { src: require("@front/assets/logo.png"), alt: "Vue logo" }
        })
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }